import { render, staticRenderFns } from "./ETPraticaTrasportoPrincipaleMare.vue?vue&type=template&id=71a91fa6&scoped=true&"
import script from "./ETPraticaTrasportoPrincipaleMare.vue?vue&type=script&lang=js&"
export * from "./ETPraticaTrasportoPrincipaleMare.vue?vue&type=script&lang=js&"
import style0 from "./ETPraticaTrasportoPrincipaleMare.vue?vue&type=style&index=0&id=71a91fa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a91fa6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71a91fa6')) {
      api.createRecord('71a91fa6', component.options)
    } else {
      api.reload('71a91fa6', component.options)
    }
    module.hot.accept("./ETPraticaTrasportoPrincipaleMare.vue?vue&type=template&id=71a91fa6&scoped=true&", function () {
      api.rerender('71a91fa6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/pratica/express-trailers/ETPraticaTrasportoPrincipaleMare.vue"
export default component.exports